import React from "react";
import { useNavigate } from "react-router-dom";

function ReturnToSencoResults(props) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <img
      src={process.env.PUBLIC_URL + "/assets/imgs/arrow-left.svg"}
      alt="Back"
      className="back-arrow"
      onClick={handleBackClick}
      style={{ cursor: "pointer" }}
    />
  );
}

export default ReturnToSencoResults;
